import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appNumericOnlyZeroNine]'
})
export class NumericOnlyDirectiveZeroNine {
  private hasEnteredDigit: boolean = false;

  constructor(private el: ElementRef) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // const value = (event.target as HTMLInputElement).value;
    const isNumeric = /^[1-9]$/.test(event.key); // Adjusted regular expression
    const isSpecialKey = /^(Backspace|Tab|ArrowDown|ArrowLeft|ArrowRight|ArrowUp|Delete)$/.test(event.key);

    if (this.hasEnteredDigit && isNumeric) {
      event.preventDefault();
    } else if (!this.hasEnteredDigit && isNumeric) {
      this.hasEnteredDigit = true;
    } else if (this.hasEnteredDigit && isSpecialKey && event.key === 'Backspace') {
      this.hasEnteredDigit = false;
    }
  }
}
